import { gql, TypedDocumentNode } from "@apollo/client";

import {
  EntityChangePhase,
  EntityChangeType,
  EntityChangeV2,
  ManagedEntityV2,
  PageInfo,
  Run,
  Stack,
} from "types/generated";

export type RunChangeV2Node = Pick<EntityChangeV2, "phase" | "type"> & {
  entity: Pick<ManagedEntityV2, "address" | "id" | "name">;
};

export type GetRunChangesData = {
  stack:
    | (Pick<Stack, "id"> & {
        run:
          | (Pick<Run, "id" | "title"> & {
              changesV2: {
                edges: {
                  cursor: string;
                  node: RunChangeV2Node;
                }[];
                pageInfo: Pick<PageInfo, "endCursor" | "hasNextPage">;
              } | null;
            })
          | null;
      })
    | null;
};

export type GetRunChangesVariables = {
  stackId: string;
  runId: string;
  changeType: EntityChangeType;
  phaseType: EntityChangePhase;
  limit?: number | null;
  offset?: string | null;
};

export const GET_CHANGES: TypedDocumentNode<GetRunChangesData, GetRunChangesVariables> = gql`
  query GetRunChanges(
    $stackId: ID!
    $runId: ID!
    $changeType: EntityChangeType!
    $phaseType: EntityChangePhase!
    $limit: Int
    $offset: String
  ) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        title
        changesV2(
          input: { first: $limit, changeType: $changeType, changePhase: $phaseType, after: $offset }
        ) {
          edges {
            cursor
            node {
              entity {
                address
                id
                name
              }
              type
              phase
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
`;
